<template>
  <div>
    <Topo :btnLogout="true" :acessoRestritoMenu="true"></Topo>
    <Migalha label="Validação"></Migalha>
    <v-card>
      <v-form ref="formPesquisar" v-model="valid">
        <v-layout row wrap>
          <v-flex xs12 sm4 md3 p-t-20>
            <v-select v-model="model.situacaoSolicitacao" :items="enumSituacaoSolicitacao" item-text="descricao"
              item-value="valor" :label="$t('label.situacaoSolicitacao')" clearable></v-select>
          </v-flex>

          <v-flex xs12 sm4 md2 p-t-20>
            <v-select v-model="model.tipoSolicitacao" :items="enumTtipoSolicitacao" item-text="descricao"
              item-value="valor" :label="$t('label.tipoSolicitacao')" clearable></v-select>
          </v-flex>

          <v-flex xs12 sm4 md2 p-t-20>
            <v-select v-model="model.tipoCertificado" :items="enumTtipoCertificado" item-text="descricao"
              item-value="valor" :label="$t('label.tipoCertificado')" clearable></v-select>
          </v-flex>

          <v-flex xs12 sm12 md5 p-t-20>
            <fieldset>
              <legend>Natureza</legend>
              <v-layout row wrap>
                <v-flex xs6>
                  <v-switch v-model="model.tipFornecedor" :label="$t('label.pessoaJurica')" color="info" value="J"
                    hide-details></v-switch>
                </v-flex>
                <v-flex xs6>
                  <v-switch v-model="model.tipFornecedor" :label="$t('label.pessoaFisica')" color="info" value="F"
                    hide-details></v-switch>
                </v-flex>
              </v-layout>
            </fieldset>
          </v-flex>

          <v-flex xs12 sm6 md3 p-t-20>
          <v-text-field
  v-model="model.numCgcFornecedor"
  :label="(model.tipFornecedor =='J') ? $t('label.cnpj') : (model.tipFornecedor =='F') ? $t('label.cpf') : $t('label.cpfCnpj')"
  @input="model.numCgcFornecedor = $event.toUpperCase()"
  maxlength="18"
>
  <the-mask
    slot-scope="{ on, attrs }"
    v-bind="attrs"
    v-on="on"
    v-model="model.numCgcFornecedor"
    :mask="getCpfCnpjMask()"
    :tokens="{ 
      'X': { pattern: /[0-9a-zA-Z]/, persistent: true } 
    }"
    masked
  />
</v-text-field>
          </v-flex>
          <v-flex xs20 sm6 md4 p-t-20>
            <v-text-field v-model="model.nomFornecedor" :label="
              model.tipFornecedor == 'J'
                ? $t('label.razaoSocial')
                : model.tipFornecedor == 'F'
                  ? $t('label.nome')
                  : 'Razão Social/Nome'
            "></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 md5 p-t-20>
            <v-layout row wrap>
              <v-flex xs6>
                <v-switch v-model="model.filtroUnidadeSolicitante" :label="$t('label.unidadeSolicitante')">
                </v-switch>
              </v-flex>
              <v-flex xs6 v-if="$verificaPerfilHabilitadorMaster()">
                <v-switch v-model="model.filtroAtualizaCertidao" :label="$t('label.atualizacaoCertidao')" true-value="1"
                  false-value="0">
                </v-switch>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm6 md3>
            <datePicker v-model="model.dataSolicitacao" v-mask="maskData" :dataDefault="model.dataSolicitacao"
              :label="$t('label.dataInicio')" :rules="[]" />
          </v-flex>
          <v-flex xs12 sm6 md3>
            <datePicker v-model="model.dataFinalSolicitacao" v-mask="maskData" :dataDefault="model.dataFinalSolicitacao"
              :label="$t('label.dataFinal')" :rules="[]" />
          </v-flex>
          <v-flex xs12 sm6 md6 grow>
            <v-combobox clearable v-model="model.analista" :return-object="true" :items="comboAnalistasFiltro"
              :label="$t('label.analista')" item-text="nome"></v-combobox>
          </v-flex>
          <v-flex xs12 sm6 md4 grow>
            <v-combobox v-model="model.localidade" :return-object="true" :items="comboLocalidades"
              :label="$t('label.localidades')" item-text="nome"></v-combobox>
          </v-flex>
          <v-flex xs12 sm6 md4 grow>
            <v-combobox clearable v-model="unidadeSolicitacao" :items="listaUnidadesSolicitacao"
              :label="$t('label.unidadeSolicitante')" :return-object="true" item-text="nome" item-value="nome"
              :loading="loadingUnidades"></v-combobox>
          </v-flex>
          <v-flex xs12 sm6 md4>
            <v-text-field v-model="model.numeroSolicitacao" :label="$t('label.numeroSolicitacao')"
              :rules="[]"></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md4>
            <v-switch v-model="model.filtroSolicitacoesVencidas" :label="$t('label.solicitacoesVencidas')"
              true-value="1" false-value="0">
              ></v-switch>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs8 sm10 md3 p-t-15>
            <v-btn large color="danger" @click="selecionarTodosCheck()" v-if="$verificaPerfilHabilitadorMaster()">
              {{
                  this.documentsSelectedList.length === 0
                    ? "Selecionar Todos"
                    : "Limpar seleção"
              }}
            </v-btn>
          </v-flex>

          <v-flex xs8 sm10 md3 p-t-15 v-show="$verificaPerfilHabilitadorMaster()">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" 
                  @click="atribuirAnalistaCheck(on, $event)" large color="warning">Atribuir Analista</v-btn>
              </template>
              <span class="tamFontTool">Selecione 1 ou mais solitações para atribuir analista</span>
            </v-tooltip>
          </v-flex>

          <v-flex xs8 sm10 md3 p-t-15>
            <v-btn large color="info" @click="carregarTabelaCadastrados(true)">Pesquisar</v-btn>
          </v-flex>

          <v-flex xs4 sm2 md1 p-t-15 v-show="listaFornec.length">
            <a color="info" @click="exportarExcel()">
              <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="48" height="48" viewBox="0 0 192 192"
                style=" fill:#000000;">
                <g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt"
                  stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0"
                  font-family="none" font-weight="none" font-size="none" text-anchor="none"
                  style="mix-blend-mode: normal">
                  <path d="M0,192v-192h192v192z" fill="none"></path>
                  <g fill="#2ecc71">
                    <path
                      d="M96,24l-80,16v112l80,16zM112,40v16h16v16h-16v16h16v16h-16v16h16v16h-16v16h56c4.416,0 8,-3.584 8,-8v-96c0,-4.416 -3.584,-8 -8,-8zM144,56h16v16h-16zM33.40625,66.375h14.21875l7.39062,17.71875c0.6,1.448 1.05163,3.12725 1.51562,5.03125h0.20313c0.264,-1.144 0.80138,-2.89187 1.60938,-5.17187l8.23437,-17.57813h12.96875l-15.48438,29.35938l15.9375,29.89062h-13.82812l-8.90625,-19.3125c-0.336,-0.68 -0.7345,-2.04912 -1.0625,-3.95312h-0.125c-0.2,0.912 -0.60312,2.27738 -1.20312,4.10938l-8.98438,19.15625h-13.89062l16.48438,-29.65625zM144,88h16v16h-16zM144,120h16v16h-16z">
                    </path>
                  </g>
                </g>
              </svg>
            </a>
          </v-flex>

        </v-layout>
      </v-form>
      <v-flex>
        <v-data-table :headers="headers" :items="listaFornec" :pagination.sync="pagination" :disable-initial-sort="true"
          class="tableLista" :total-items="pagination.totalItems" :rowsPerPageItems="[pagination.rowsPerPage]">
          <template slot="items" slot-scope="props"
          >
          <tr v-bind:class="{ 'linha-azul': props.item.situacaoSolicitacao === 11 }">
            <v-checkbox
              :input-value="props.all"
              :indeterminate="props.indeterminate"
              primary hide-details
              :value="props.item.idFornecSolicitacao"
              :solicitacao="props.item"
              v-model="documentsSelectedList"
              @change="check(props.item.idFornecSolicitacao, documentsSelectedList)"
              v-show="$verificaPerfilHabilitadorMaster()"
            >
            </v-checkbox>

            <td nowrap="nowrap" class="text-xs-center"
            >
              <v-tooltip top v-show="fnPodeValidar(props.item)">
                <v-btn slot="activator" icon @click="
                  (props.item.situacaoSolicitacao != 10 &&
                    props.item.situacaoSolicitacao != 3 && props.item.situacaoSolicitacao != 11) ||
                    $verificaPerfilHabilitadorMaster()
                    ? openModalAtribuirAnalista(props.item, true)
                    : ''
                ">
                  <v-icon :color="
                    defineCorIconeSolicitacao(props.item.situacaoSolicitacao)
                  ">spellcheck</v-icon>
                </v-btn>
                <span>{{
                    (props.item.situacaoSolicitacao != 10 &&
                      props.item.situacaoSolicitacao != 3 && props.item.situacaoSolicitacao != 11) || 
                      $verificaPerfilHabilitadorMaster()
                      ? "Validar Solicitação"
                      : "-"
                }}</span>
              </v-tooltip>

              <v-tooltip top v-show="fnPodeContinuarValidar(props.item)">
                <v-btn slot="activator" icon @click="editItem(props.item.idFornecSolicitacao)">
                  <v-icon color="primary">edit</v-icon>
                </v-btn>
                <span>Continuar Validação</span>
              </v-tooltip>
            </td>
            <td nowrap v-bind:class="{
              'cpf-servidor':
                props.item.isFuncionarioPublico ||
                props.item.fornecedoresHabilitacaoJuridica.find(
                  (x) => x.isFuncionarioPublico
                ),
              dataVencida: props.item.validadeSolicitacao == '1',
            }">
              <a v-show="
                props.item.isFuncionarioPublico ||
                props.item.fornecedoresHabilitacaoJuridica.find(
                  (x) => x.isFuncionarioPublico
                )
              ">
                <v-tooltip top>
                  <v-icon class="mx-1" slot="activator" :size="20" color="red">info</v-icon>

                  <span>Esta solicitação contém CPF de Servidor Público</span>
                </v-tooltip>
              </a>
              {{ props.item.numCgcFornecedor | formatCpfCnpj }}
              <span class="tooltipHint" v-show="props.item.tipoSolicitacao == 2">*Solicitação Alteração</span>
            </td>
            <td class="text-xs-left" nowrap v-bind:class="{
              dataVencida: props.item.validadeSolicitacao == '1',
            }">
              {{ props.item.nomFornecedor }}
            </td>
            <td class="text-xs-left" nowrap v-bind:class="{
              dataVencida: props.item.validadeSolicitacao == '1',
            }">
              {{ props.item.numSolicitacao }}
            </td>
            <td class="text-xs-center" nowrap v-bind:class="{
              dataVencida: props.item.validadeSolicitacao == '1',
            }">
              {{ props.item.dataSolicitacao | dataHoraFormatada }}
            </td>
            <td v-if="$verificaPerfilHabilitadorMaster()" class="text-xs-center" nowrap v-bind:class="{
              dataVencida: props.item.validadeSolicitacao == '1',
            }">
              {{ props.item.tipoSolicitacaoStr }}
            </td>
            <td class="text-xs-center" nowrap v-if="
              props.item.hasTermoConcordanciaVeracidade &&
              $verificaPerfilHabilitadorMaster()
            " v-bind:class="{
                    dataVencida: props.item.validadeSolicitacao == '1',
                  }">
              {{ props.item.termoConcordancia.dtAceitacao | dataHoraFormatada }}
            </td>
            <td class="text-xs-center" nowrap v-else-if="$verificaPerfilHabilitadorMaster()" v-bind:class="{
              dataVencida: props.item.validadeSolicitacao == '1',
            }">
              {{ props.item.dtAceitacao }}
            </td>
            <div v-if="$verificaPerfilHabilitadorMaster()">
              <td style="padding-top: 13px" class="text-xs-left" nowrap
                v-if="props.item.situacaoSolicitacaoStr === 'Aceitar'" v-bind:class="{
                  dataVencida: props.item.validadeSolicitacao == '1',
                }">
                Aguardando análise
              </td>
              <td style="padding-top: 13px" class="text-xs-left" nowrap
                v-else-if="props.item.situacaoSolicitacaoStr === 'Rejeitar'" v-bind:class="{
                  dataVencida: props.item.validadeSolicitacao == '1',
                }">
                Indeferida
              </td>
              <td style="padding-top: 13px" class="text-xs-left" nowrap v-else v-bind:class="{
                dataVencida: props.item.validadeSolicitacao == '1',
              }">
                {{ props.item.situacaoSolicitacaoStr }}
              </td>
            </div>
            <td v-if="$verificaPerfilHabilitadorMaster()" class="text-xs-center" nowrap v-bind:class="{
              dataVencida: props.item.validadeSolicitacao == '1',
            }">
              {{ props.item.situacaoSimpasStr }}
            </td>
            <td class="text-xs-left tdAnalista" nowrap>
              <div v-if="!$verificaPerfilHabilitadorMaster()">
                {{ props.item.nomAnalista }}
              </div>
              <div style="width:300px" v-if="
                $verificaPerfilHabilitadorMaster() &&
                !reload['combo_' + props.item.idFornecSolicitacao]
              ">
                <v-combobox v-if="props.item.situacaoSolicitacao !== 11" v-model="props.item.usuarioAnalista" :return-object="true" :items="comboAnalistas"
                  item-text="nome" @input="
                    openModalAtribuirAnalista(
                      props.item,
                      false,
                      'combo_' + props.item.idFornecSolicitacao
                    )
                  " dense :readonly="documentsSelectedList.length > 1" validate-on-blur v-bind:class="{
                  dataVencida: props.item.validadeSolicitacao == '1',
                }"></v-combobox>

                <v-combobox v-if="props.item.situacaoSolicitacao === 11" v-model="props.item.nomAnalistaDuplaConferencia" :return-object="true" :items="comboAnalistas"
                  item-text="nome" @input="
                    openModalAtribuirAnalista(
                      props.item,
                      false,
                      'combo_' + props.item.idFornecSolicitacao
                    )
                  " dense :readonly="documentsSelectedList.length > 1" validate-on-blur v-bind:class="{
                  dataVencida: props.item.validadeSolicitacao == '1',
                }"></v-combobox>

              </div>
            </td>
            <td class="text-xs-left" nowrap v-bind:class="{
              dataVencida: props.item.validadeSolicitacao == '1',
            }">
              {{
                  props.item.unidadeSolicitacaoDescr
                    ? props.item.unidadeSolicitacaoDescr
                    : "-"
              }}
            </td>
            <td class="text-xs-left" nowrap v-bind:class="{
              dataVencida: props.item.validadeSolicitacao == '1',
            }">
              {{ props.item.nomPCF }}
            </td>
            </tr>
          </template>
        </v-data-table>
        <v-flex>
          <v-icon color="blue">spellcheck</v-icon>
          <span> - Em Análise </span>
          <v-icon color="primary">edit</v-icon>
          <span> - Continuar Validação </span>
          <v-icon color="green">spellcheck</v-icon>
          <span> - Validar Solicitação </span>
          <v-icon color="red">list</v-icon>
          <span v-bind:class="{ dataVencida: true }">
            Solicitação com mais de 05 dias úteis pendente de validação
          </span>
          <v-icon color="blue">list</v-icon>
          <span class="linha-azul">Pendente de Conferência</span>
        </v-flex>
      </v-flex>
    </v-card>

    <v-dialog v-model="dialogAtribuirAnalista.show" persistent max-width="520px">
      <v-card>
        <v-card-title class="headline">Confirme!</v-card-title>
        <v-card-text>
          <div v-html="dialogAtribuirAnalista.texto()"></div>
          <strong>{{ this.model.numSolicitacao }}</strong>.
        </v-card-text>
        <v-layout row p-b-15 p-t-10>
          <v-flex sm6>
            <v-btn large color="success" :disabled="desativarBotaoConfirmar"
              @click="cancelarAtribuirAnalista()">Cancelar</v-btn>
          </v-flex>
          <v-flex sm6 v-if="this.documentsSelectedList.length > 1">
            <v-btn large :disabled="desativarBotaoConfirmar" color="info" @click="
              listaSolitacoes(), limparPosSave()
            ">Confirmar</v-btn>
          </v-flex>

          <v-flex sm6 v-if="this.documentsSelectedList.length == 0 || this.documentsSelectedList.length == 1">
            <v-btn large color="info" :disabled="desativarBotaoConfirmar" @click="
              verificarSituacaoSolicitacao(dialogAtribuirAnalista.solicitacao)
            ">Confirmar</v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogAtribuirAnalista3.show" persistent max-width="520px">
      <v-card>
        <v-card-title class="headline">Confirme!</v-card-title>
        <v-card-text>
          Escolha um analista que deseja habilitar para seleção escolhida

          <!-- Nesse combobox chegam todos registros da tela de validação -->
          <v-combobox
            :value=setNomeAnalista()
            :return-object="true"
            :items="comboAnalistas"
            item-text="nome"
            @input="
            openModalAtribuirAnalista2(
              false,
              documentsSelectedList,
              $event
            )"
            dense
            validate-on-blur
          ></v-combobox>
        </v-card-text>
        <v-layout row p-b-15 p-t-10>
          <v-flex class="text-md-center">
            <v-btn large color="success" @click="cancelarAtribuirAnalista2()">Cancelar</v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogAtribuirAnalista4.show" persistent max-width="520px">
      <v-card>
        <v-card-title class="headline">Confirme!</v-card-title>
        <v-card-text>
          Escolha um analista que deseja habilitar para seleção escolhida

          <!-- Nesse combobox chegam todos registros da tela de validação -->
          <v-combobox
            :value=setNomeAnalista()
            :return-object="true"
            :items="comboAnalistas"
            item-text="nome"
            @input="
            openModalAtribuirAnalista2(
              false,
              documentsSelectedList,
              $event
            )"
            dense
            validate-on-blur
          ></v-combobox>
        </v-card-text>

        <v-layout row p-b-15 p-t-10>
          <v-flex sm6>
            <v-btn large color="success" :disabled="desativarBotaoConfirmar"
              @click="cancelarAtribuirAnalista()">Cancelar</v-btn>
          </v-flex>
          <v-flex sm6 v-if="this.documentsSelectedList.length > 1">
            <v-btn large :disabled="desativarBotaoConfirmar" color="info" @click="
              listaSolitacoes(), limparPosSave()
            ">Confirmar</v-btn>
          </v-flex>

          <v-flex sm6 v-if="this.documentsSelectedList.length == 0 || this.documentsSelectedList.length == 1">
            <v-btn large color="info" :disabled="desativarBotaoConfirmar" @click="
              verificarSituacaoSolicitacao(dialogAtribuirAnalista.solicitacao)
            ">Confirmar</v-btn>
          </v-flex>
        </v-layout>       
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import util from "../../../plugins/util"; /*Objeto com metodos e funcoes utilizadas pelo sistema */
import Migalha from "../../../components/migalha";
import Topo from "../../../components/Topo";
import fornecedorService from "../../../services/fornecedorService"; /*Objeto com os principais servicos de Fornecedor */
import usuarioService from "../../../services/usuarioService";
import dominioService from "../../../services/dominioService";

export default {
  name: "solicitacao-fornecedor",
  mixins: [util],
  components: {
    /*Componentes utilizados*/
    Migalha,
    Topo,
  },
  data() {
    //Declaracao de variaveis
    return {
      desativarBotaoConfirmar: false,
      msgAtribuirAnalista: false,
      isReadonly: false,
      enumSituacaoSolicitacao: [],
      enumTtipoSolicitacao: [],
      colecaoIdSolicitacao: [],
      enumTtipoCertificado: [],
      solicitacaoCompleta: [],
      listagemForncSolic: [],
      reload: {},
      nomesAnalistas: [],
      colecaoAnalistas: [],
      valorComboModal: [],
      idSolicitacaoAnalista: [],
      guardaValidador: [],
      checkedClear: [],
      documentsSelectedList: [],
      documentsSelectedListNome: [],
      dialogAtribuirAnalista: {
        show: false,
        nomeAnalista: "",
        nomeAnalistaAnterior: "",
        usuarioAnalistaId: null,
        tipos: { novo: 1, troca: 2, habilitador: 3 },
        solicitacao: {},
        tipo: 1,
        self: false,
        combo: null,
        texto: function () {
          var msg = "";

          switch (this.tipo) {
            case this.tipos.novo:
              msg =
                "Você confirma <b>" +
                this.nomeAnalista +
                "</b> para analisar essa solicitação?";

              break;

            case this.tipos.troca:
              msg =
                "Você confirma a troca do analista <b>" +
                this.nomeAnalistaAnterior +
                "</b> para  <b>" +
                this.nomeAnalista +
                "</b> para analisar essa solicitação?";

              break;

            case this.tipos.habilitador:
              msg =
                "Ao clicar em  <b>CONFIRMAR</b> essa solicitação ficará exclusiva para sua analise.";
              break;
          }
          return msg;
        },
      },
      dialogAtribuirAnalista3: {
        show: false,
        nomeAnalista: "",
        nomeAnalistaAnterior: "",
        usuarioAnalistaId: null,
        tipos: { novo: 1, troca: 2, habilitador: 3 },
        solicitacaoatrib: {},
        tipo: 1,
        self: false,
        combo: null,
        texto: function () {
          var msg = "";

          switch (this.tipo) {
            case this.tipos.novo:
              msg =
                "Você confirma 3 <b>" +
                this.nomeAnalista +
                "</b> para analisar essa solicitação?";

              break;

            case this.tipos.troca:
              msg =
                "Você confirma 3 a troca do analista <b>" +
                this.nomeAnalistaAnterior +
                "</b> para  <b>" +
                this.nomeAnalista +
                "</b> para analisar essa solicitação?";

              break;

            case this.tipos.habilitador:
              msg =
                "Ao clicar em  <b>CONFIRMAR</b> essa solicitação ficará exclusiva para sua analise.";
              break;
          }
          return msg;
        },
      },
      dialogAtribuirAnalista4: {
        show: false,
        nomeAnalista: "",
        nomeAnalistaAnterior: "",
        usuarioAnalistaId: null,
        tipos: { novo: 1, troca: 2, habilitador: 3 },
        solicitacaoatrib: {},
        tipo: 1,
        self: false,
        combo: null,
        texto: function () {
          var msg = "";

          switch (this.tipo) {
            case this.tipos.novo:
              msg =
                "Você confirma 3 <b>" +
                this.nomeAnalista +
                "</b> para analisar essa solicitação?";

              break;

            case this.tipos.troca:
              msg =
                "Você confirma 3 a troca do analista <b>" +
                this.nomeAnalistaAnterior +
                "</b> para  <b>" +
                this.nomeAnalista +
                "</b> para analisar essa solicitação?";

              break;

            case this.tipos.habilitador:
              msg =
                "Ao clicar em  <b>CONFIRMAR</b> essa solicitação ficará exclusiva para sua analise.";
              break;
          }
          return msg;
        },
      },
      pagination: {
        rowsPerPage: 10,
        totalItems: 0,
        page: 1,
        descending: false,
        sortBy: "dataSolicitacao",
      },
      valid: true,
      enums: {},
      selected: [],
      headers: [
        /*Cabeçalho da data-table*/
        { text: "", value: "", width: 10, sortable: false },
        { text: "Ações", value: "", width: 10, sortable: false },
        { text: "CNPJ/CPF", width: 100, sortable: false },
        {
          text: "Razão Social/Nome",
          width: 400,
          sortable: true,
          value: "nomFornecedor",
        },
        { text: "Nº Solicitação", width: 100, sortable: false },
        {
          text: "Data Solicitação",
          width: 220,
          align: "center",
          sortable: true,
          value: "dataSolicitacao",
        },
        {
          text: "Tipo Solicitação",
          sortable: true,
          value: "tipoSolicitacaoStr",
        },
        {
          text: "Data Validação Termo",
          width: 220,
          align: "center",
          sortable: true,
          value: "dtAceitacao",
        },
        { text: "Situação Solicitação", width: 100, sortable: true },

        {
          text: "Situação CAF Digital",
          width: 100,
          align: "center",
          sortable: false,
        },
        { text: "Analista", width: 300, sortable: false },
        { text: "Unidade Solicitação", width: 300, sortable: false },
        {
          text: "Localidade",
          width: 20,
          sortable: false,
          value: "nomPCF",
        },
      ],
      model: {
        dataSolicitacao: null,
        dataFinalSolicitacao: null,
        situacaoSolicitacao: null,
        tipFornecedor: null,
        numCgcFornecedor: null,
        nomFornecedor: null,
        nomPCF: null,
        dtAceitacao: null,
        numeroSolicitacao: null,
        analista: null,
        filtroAnalista: null,
        localidade: null,
        unidadeSolicitacao: null,
        filtroAtualizaCertidao: "0",
        filtroSolicitacoesVencidas: "0",
      },
      listaFornec: [],
      listaFornecFiltrada: [],
      vetorColecao: [],
      listaUnidadesSolicitacao: [],
      paginaAtual: 1,
      totalItems: 0,
      comboAnalistas: [],
      analistaSelecionado: [],
      comboLocalidades: ["UEFS", "UESB", "UESC", "SSA"],
      loadingUnidades: false,
      unidadeSolicitacao: { id: 0, nome: "Todas" },
    };
  },
  created() /*Metodo de start do componente*/ {
    if (!this.$verificaPerfilHabilitador()) {
      this.$toasted.error(this.$t("messages.validacao.usuarioSemPermissao"));
      this.$router.push("/loginrestrito");
    } else {
      this.loadingUnidades = true;
      dominioService
        .getTodasUnidades()
        .then((response) => {
          if (response.data != null) {
            let unidades = response.data;
            this.listaUnidadesSolicitacao = [{ id: "0", nome: "Todas" }].concat(
              unidades.map((u) => {
                return {
                  id: `${u.codSecretaria}.${u.numUnidade}`,
                  nome: `${u.codSecretaria}.${u.numUnidade} - ${u.secretariaSigla
                    }/${u.descUnidade}`,
                };
              })
            );
          }
          this.loadingUnidades = false;
        })
        .catch(() => {
          this.loadingUnidades = false;
        });
      if (this.$verificaPerfilHabilitador()) {
        usuarioService.getUsuariosHabilitador().then((response) => {
          /*resposta do servico*/
          this.comboAnalistas = response.data; /*dados de retorno*/
          // this.carregarTabelaCadastrados();
        });
      } else {
        // this.carregarTabelaCadastrados();
      }
    }

    dominioService.geEnums().then((response) => {
      /*resposta do servico*/
      this.enums = response.data; /*dados de retorno*/
      this.enumSituacaoSolicitacao = this.enums.situacaoSolicitacao.filter(
        (x) => x.chave === "Aceitar" || x.chave === "EmAnalise" || x.chave === "PreDeferida"
      );
      this.enumSituacaoSolicitacao.forEach((el) => {
        if (el.chave === "Aceitar") el.descricao = "Validar Solicitação";
        if (el.chave === "PreDeferida") el.descricao = "Pré-deferida";
      });
      
      this.enumSituacaoSolicitacao.push({
        descricao: "Continuar Validação",
        valor: -1,
      });
      this.enumTtipoSolicitacao = this.enums.tipoSolicitacao.filter(
        (x) =>
          x.chave === "SolicitacaoNova" || x.chave === "SolicitacaoAlteracao"
      );
      this.enumTtipoSolicitacao.filter((x) => {
        if (x.chave === "SolicitacaoNova") {
          x.descricao = "Inscrição";
        }
      });
      this.enumTtipoCertificado = this.enums.tipoCertificado;
    });
  },
  //Campos computados
  computed: {
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
    comboAnalistasFiltro() {
      let combo = [{ nome: "Todos", id: 0 }];
      combo = combo.concat(this.comboAnalistas);
      return combo;
    },
  },
  //Propriedades assistidas
  watch: {
    pagination: {
      handler(newValue, oldValue) {
        if (Object.keys(oldValue).length > 2) {
          this.pagination.sortBy = newValue.sortBy;
          this.pagination.descending = newValue.descending ? true : false;
          this.carregarTabelaCadastrados();

        }
      },
    },
    "model.analista": {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          if (newValue == null) {
            this.model.filtroAnalista = null;
          } else {
            this.model.filtroAnalista = newValue.nome;
          }
        }
      },
    },
    "pagination.page": {
      handler() {
        this.carregarTabelaCadastrados();

      },
      deep: true,
    },
  },
  beforeDestroy() {
    clearTimeout(this._timerId);
  },
  methods: {
    setNomeAnalista() {
      if (this.documentsSelectedList.length > 1) {
        return 'Selecione um nome para atribuir analista';
      }
      return this.nomesAnalistas[0];
    },

    //Declaracao de todos os metodos
    limparPosSave() {
      this.dialogAtribuirAnalista3.show = false;      
      this.documentsSelectedList = [];
    },

    check(e, v) {      
      this.colecaoAnalistas = [];

      this.colecaoAnalistas = v;

      let arrayX = [];
      this.$nextTick(() => {
        this.listaFornec.forEach((document) => {
          let ajuda = true;
          if (this.listagemForncSolic.length > 0) {
            for (var i = 0; i < this.listagemForncSolic.length; i++) {              
              if (this.listagemForncSolic[i].idFornecSolicitacao == document.idFornecSolicitacao) {
                ajuda = false;
              }
            }

            if (ajuda) {
              arrayX.push(document)
            }
          } else {
            arrayX.push(document)
          }
        });

        arrayX.forEach(element => {
          this.listagemForncSolic.push(element)
        });

        this.listagemForncSolic.forEach((document) => {         
          v.forEach(x => {
            if (document.idFornecSolicitacao == x) {             
              //this.colecaoIdSolicitacao.push(document.idFornecSolicitacao)
              if (document.usuarioAnalista != undefined) {
                this.nomesAnalistas.push(document.usuarioAnalista.nome);            
              }
            }
          })
        })
      })
    },

    atribuirAnalistaCheck({ mouseenter, mouseleave }, e) {
      this.desativarBotaoConfirmar = false;

      if (this.documentsSelectedList.length === 0) {
        clearTimeout(this._timerId);
        mouseenter(e);
        this._timerId = setTimeout(() => mouseleave(e), 3000);

        return false;
      }
      this.dialogAtribuirAnalista3.show = true;
      //this.dialogAtribuirAnalista4.show = true;
    },

    selecionarTodosCheck() {
      const documentsSelectedList = [];
      const documentsSelectedListNome = [];
      if (this.documentsSelectedList.length === 0) {
        this.model.TodosResultados = true;
        fornecedorService
          .getSolicitacaoFornecedor(this.model)
          .then((response) => {

            response.data.fornecedorLista.forEach((item) => {
              item.usuarioAnalista = this.comboAnalistas.find(
                (x) => x.id == item.usuarioAnalistaId
              );
              documentsSelectedList.push(item.idFornecSolicitacao);
              documentsSelectedListNome.push(item.usuarioAnalista);
            });
          });

        this.documentsSelectedList = documentsSelectedList;
        this.documentsSelectedListNome = documentsSelectedListNome;
      } else {
        this.documentsSelectedList = [];
        this.documentsSelectedListNome = [];
      }
      
      this.colecaoAnalistas = [];

      this.colecaoAnalistas = this.documentsSelectedList

  let arrayX = [];
      
        this.listaFornec.forEach((document) => {
          let ajuda = true;
          if (this.listagemForncSolic.length > 0) {
            for (var i = 0; i < this.listagemForncSolic.length; i++) {              
              if (this.listagemForncSolic[i].idFornecSolicitacao == document.idFornecSolicitacao) {
                ajuda = false;
              }
            }

            if (ajuda) {
              arrayX.push(document)
            }
          } else {
            arrayX.push(document)
          }
        });

        arrayX.forEach(element => {
          this.listagemForncSolic.push(element)
        });

        
    

    },

    exportarExcel() {
      // 1 gera excel de solicitações de fornecedores
      fornecedorService.exportarExcel(this.model, 1);
    },
    pushIfNotExists(list, word) {
      if (list.length == 0) list.push(word);
      else {
        if (!list.find((x) => x === word)) list.push(word);
      }
    },
    carregarTabelaCadastrados(pesquisar) {
      //carregar a listagem de fornecedor
      if (pesquisar) {
        this.pagination.page = 1;
        this.documentsSelectedList = [];
        this.documentsSelectedListNome = [];
        if (!this.$refs.formPesquisar.validate()) {
          return;
        }
      }

      if (this.$verificaPerfilSomenteHabilitador()) {
        //#152540 - remoção de campos abaixo para o perfil validador

        delete this.headers[5]; //Tipo Solicitação
        delete this.headers[6]; //Data Validação Termo
        delete this.headers[7]; //Situação Solicitação
        delete this.headers[8]; //Situação CAF Digital
      }
      this.model.TodosResultados = false;
      this.model.page = this.pagination.page;
      this.model.rowsPerPage = this.pagination.rowsPerPage;
      this.model.sortBy = this.pagination.sortBy;
      this.model.descending = this.pagination.descending;
      this.model.filtroAguardandoAnalise = false;
      this.model.filtroPcf = true;
      this.model.filtroSolicitacaoAtribuida =
        this.model.situacaoSolicitacao === -1;
      if (this.model.filtroSolicitacaoAtribuida) {
    
        this.model.situacaoSolicitacao = 3;
      }
      
      this.model.unidadeSolicitacao = this.unidadeSolicitacao.id;
      fornecedorService
        .getSolicitacaoFornecedor(this.model)
        .then((response) => {
          this.listaFornec = response.data.fornecedorLista;
          this.pagination.totalItems = response.data.totalItems;
          this.listaFornec.forEach((item) => {
            item.usuarioAnalista = this.comboAnalistas.find(
              (x) => x.id == item.usuarioAnalistaId
            );

            this.$set(this.reload, "combo_" + item.idFornecSolicitacao, false);
          });
          if (this.model.filtroSolicitacaoAtribuida) {
            this.model.situacaoSolicitacao = -1;
           
          }

          this.$removePreload();
        })
        .catch((error) => {
          this.$removePreload();
          if (error.status == 403) {
            Vue.toasted.error("Acesso não permitido!");
            this.$router.push("/arearestrita/habilitador/solicitacao");
          }
        });
      // Limpando a datable a cada paginação
      this.listaFornec = [];
    },

    editItem(idFornecSolicitacao) {
      //editar a solicitacao
      this.$router.push({
        path: `/arearestrita/habilitador/consultar-solicitacao/${idFornecSolicitacao}`,
      });
    },

    atribuirAnalistaFornecedor() {
      //associar a solicitacao a um habilitador
      fornecedorService
        .atribuirAnalistaFornecedor(
          this.dialogAtribuirAnalista.solicitacao,
          this.dialogAtribuirAnalista.usuarioAnalistaId
        )
        .then((response) => {
          /*resposta do servico*/
          if (this.$verificaPerfilHabilitadorMaster()) {
            if (this.dialogAtribuirAnalista.self) {
              this.editItem(response.data.idFornecSolicitacao);
              return;
            }
            this.$toasted.success(
              this.$t("messages.cadastro.analistaAssociado")
            );
            this.cancelarAtribuirAnalista();
          } else {
            this.editItem(response.data.idFornecSolicitacao);
          }
        });
    },

    listaSolitacoes() {
      // Desabilitar botão após click
      this.desativarBotaoConfirmar = true;
      
      this.atribuirAnalistaFornecedorLista(this.colecaoAnalistas);

      this.listaFornecFiltrada = [];

      this.$toasted.success(
        this.$t("messages.cadastro.analistaAssociado")
      );
    },

    verificarSituacaoSolicitacaoLista(solicitacao) {
      fornecedorService
        .getSolicitacao(solicitacao.idFornecSolicitacao)
        .then((response) => {
          let sit;

          if (solicitacao.tipoSolicitacao === 2)
            sit = response.data.novoModel.situacaoSolicitacao;
          else sit = response.data.situacaoSolicitacao;

          if (sit === 2 || sit === 3 || sit === 9 || sit === 11) {
            this.atribuirAnalistaFornecedorLista(solicitacao);
          } else {
            Vue.toasted.error("Esta solicitação não está mais disponível.");
            this.dialogAtribuirAnalista.show = false;
          }
          /*Ocultar o PreLoad*/
        })
        .catch(() => {
          this.dialogAtribuirAnalista.show = false;
        });
    },

    atribuirAnalistaFornecedorLista(solicitacao) {
      //associar a solicitacao a um habilitador
      fornecedorService
        .atribuirAnalistaFornecedorLista(
          solicitacao,
          this.dialogAtribuirAnalista.usuarioAnalistaId
        )
        .then((response) => {
          /*resposta do servico*/
          if (this.$verificaPerfilHabilitadorMaster()) {
            if (this.dialogAtribuirAnalista.self) {
              this.editItem(response.data.idFornecSolicitacao);
              return;
            }

            this.cancelarAtribuirAnalista();
          } else {
            this.editItem(response.data.idFornecSolicitacao);
          }
        });
    },

    verificarSituacaoSolicitacao(solicitacao) {
      // Desabilitar botão após click
      this.desativarBotaoConfirmar = true;

      fornecedorService
        .getSolicitacao(solicitacao.idFornecSolicitacao)
        .then((response) => {
          let sit;

          if (solicitacao.tipoSolicitacao === 2)
            sit = response.data.novoModel.situacaoSolicitacao;
          else sit = response.data.situacaoSolicitacao;
          
          if (sit === 2 || sit === 3 || sit === 9 || sit === 11) {
            this.atribuirAnalistaFornecedor();
          } else {
            Vue.toasted.error("Esta solicitação não está mais disponível.");
            // this.carregarTabelaCadastrados();
            this.dialogAtribuirAnalista.show = false;
          }
          this.$removePreload(); /*Ocultar o PreLoad*/
          this.dialogAtribuirAnalista.show = false;
        })
        .catch(() => {
          this.dialogAtribuirAnalista.show = false;
          this.$removePreload(); /*Ocultar o PreLoad*/
        });

      // Após confirmação recarrega os dados e trazem sem estarem checados
      this.documentsSelectedList = [];
      this.nomesAnalistas = [];
    },

    openModalAtribuirAnalista2(self, combo, ev) {
      this.dialogAtribuirAnalista3.show = false;     
      //this.dialogAtribuirAnalista4.show = true;
  
      combo.forEach((item) => {
        this.listagemForncSolic.filter((x) => {
          if (x.idFornecSolicitacao === item) {
            this.listaFornecFiltrada.push(x)
          }
        });
      });     

      if(this.listaFornecFiltrada.length == 0 && this.documentsSelectedList.length > 0)
      {
        if (solicitacaoatrib.usuarioAnalista) {
            this.setAnalista(solicitacaoatrib, comb);
          }
      }

      this.listaFornecFiltrada.forEach((solicitacaoatrib) => {
        let comb = 'combo_' + solicitacaoatrib.idFornecSolicitacao

        // Removendo objeto usuarioAnalista
        delete solicitacaoatrib.usuarioAnalista;

        // Adicionando objeto usuarioAnalista que vem do evento do combobox selecionado
        solicitacaoatrib["usuarioAnalista"] = ev;

        this.vetorColecao['um'] = comb;
        this.vetorColecao['dois'] = solicitacaoatrib;

        if (this.$verificaPerfilHabilitadorMaster()) {          
          if (self) {            
            this.dialogAtribuirAnalista3.solicitacao = solicitacaoatrib;
            this.dialogAtribuirAnalista3.show = true;
            this.dialogAtribuirAnalista3.tipo = 3;
            this.dialogAtribuirAnalista3.self = true;
            this.dialogAtribuirAnalista3.usuarioAnalistaId = this.$store.getters.getUsuarioId;
            return;
          }
          
          if (solicitacaoatrib.usuarioAnalista) {
            this.setAnalista(solicitacaoatrib, comb);
          }
        } else if (this.$verificaPerfilHabilitador()) {
          this.dialogAtribuirAnalista3.solicitacao = solicitacaoatrib;
          //this.dialogAtribuirAnalista3.show = true;
          this.dialogAtribuirAnalista3.tipo = 3;
          this.dialogAtribuirAnalista3.show = true;
        
        }
      }); // Fim forEach      
    },

    openModalAtribuirAnalista(solicitacao, self, combo) {
      this.desativarBotaoConfirmar = false;
 
      //abrir confirmação da associação de um novo analista
      if (this.$verificaPerfilHabilitadorMaster()) {
        if (self) {
          this.dialogAtribuirAnalista.solicitacao = solicitacao;
          this.dialogAtribuirAnalista.show = true;
          this.dialogAtribuirAnalista.tipo = 3;
          this.dialogAtribuirAnalista.self = true;
          this.dialogAtribuirAnalista.usuarioAnalistaId = this.$store.getters.getUsuarioId;

          return;
        }

        if (solicitacao.usuarioAnalista) {
          this.setAnalista(solicitacao, combo);
        }
      } else if (this.$verificaPerfilHabilitador()) {
        this.dialogAtribuirAnalista.solicitacao = solicitacao;
        this.dialogAtribuirAnalista.show = true;
        this.dialogAtribuirAnalista.tipo = 3;
      }
    },

    setAnalista(solicitacao, combo) {
      if (typeof solicitacao.usuarioAnalista == "object") {
        this.dialogAtribuirAnalista.tipo = 1;

        if (
          solicitacao.usuarioAnalistaId &&
          solicitacao.usuarioAnalista.id !== solicitacao.usuarioAnalistaId // variaveis do tipo number
        ) {
          this.dialogAtribuirAnalista.nomeAnalistaAnterior =
            solicitacao.nomAnalista;
          this.dialogAtribuirAnalista.tipo = 2;
        }

        if(solicitacao.situacaoSolicitacao !== 11){
        this.dialogAtribuirAnalista.nomeAnalista =
          solicitacao.usuarioAnalista.nome;
        this.dialogAtribuirAnalista.usuarioAnalistaId =
          solicitacao.usuarioAnalista.id;
        }
        else
        {
          this.dialogAtribuirAnalista.nomeAnalista =
          solicitacao.nomAnalistaDuplaConferencia.nome;
        this.dialogAtribuirAnalista.usuarioAnalistaId =
          solicitacao.nomAnalistaDuplaConferencia.id;
        }
        this.dialogAtribuirAnalista.solicitacao = solicitacao;
        this.dialogAtribuirAnalista.show = true;
      } else {
        if (combo) {
          this.reload[combo] = true;
        }
        this.cancelarAtribuirAnalista();
      }
    },

    cancelarAtribuirAnalista2() {
      this.dialogAtribuirAnalista3.show = false;
      this.documentsSelectedList = [];
      this.nomesAnalistas = [];
     // this.colecaoAnalistas = [];
      this.carregarTabelaCadastrados();
    },
    cancelarAtribuirAnalista() {
      //cancelar a associacao de analista
      this.dialogAtribuirAnalista.nomeAnalista = "";
      this.dialogAtribuirAnalista.show = false;
      this.dialogAtribuirAnalista.usuarioAnalistaId = null;
      this.dialogAtribuirAnalista.solicitacao = {};

      // Após confirmação recarrega os dados e trazem sem estarem checados
      this.documentsSelectedList = [];
      this.nomesAnalistas = [];
      this.carregarTabelaCadastrados();
    },
    fnPodeValidar(item) {
      //verificar se a solicitacoa pode ser validada
      if (this.$verificaPerfilHabilitador() && ((item.usuarioAnalistaId == null && item.situacaoSolicitacao != 11)|| (item.usuarioAnalistaIdDuplaConferenciaId == null && item.situacaoSolicitacao == 11) ))
        return true;

      return false;
    },
    fnPodeContinuarValidar(item) {
     
      //verificar se pode ser continuada a validação da solicitacao
      if (    
        this.$verificaPerfilHabilitador() &&
        ((item.situacaoSolicitacao === 3 && String(item.usuarioAnalistaId) === this.$store.getters.getUsuarioId ) 
        || (item.situacaoSolicitacao === 11 && String(item.usuarioAnalistaIdDuplaConferenciaId) === this.$store.getters.getUsuarioId )) //item.usuarioAnalistaId= number, $store.getters.getUsuarioId= string
      ) {
        return true;
      }
      return false;
    },
    defineCorIconeSolicitacao(idSituacaoSolicitacao) {
      switch (idSituacaoSolicitacao) {
        case 2:
          return "grey";
        case 3:
          return "blue";
        case 9:
          return "green";
        case 10:
          return "red";
           case 11:
          return "green";
        default:
          return "grey";
      }
    },
    filtrarSolicitacoesAtribuidas() {
      this.listaFornec = this.listaFornec.filter((x) =>
        this.fnPodeContinuarValidar(x)
      );
    },
  },
};
</script>

<style>
.tableLista .v-table {
  width: auto !important;
  max-width: none !important;
}

.tdAnalista .v-text-field,
.tdAnalista .v-input__slot {
  margin: 0 !important;
  padding: 0 !important;
}

.tdAnalista .v-messages {
  display: none;
}

.tdAnalista .error--text .v-input__slot::before,
.tdAnalista .error--text .v-select__slot::before {
  border: solid 1px #ff5252 !important;
}

.tamFontTool {
  font-size: 15px;
}

  .linha-azul {
    background-color: rgb(123, 170, 227);
  }

</style>
